import { GET_CATEGORIES } from 'admin/constants';

const initialState = '';

export default function isBusyReducer(state = initialState, { type, payload }) {
	switch (type) {
		case GET_CATEGORIES.START:
			return 'categories';

		case GET_CATEGORIES.SUCCESS:
			return '';

		default:
			return state;
	}
}
